export const RQ_GET_SALON_REPORT_API = {
  url: 'salonmaster/salon-report-by/<%= divisionId %>',
  method: 'GET',
  auth: true,
};
